"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DialogContent_component_exports = {};
__export(DialogContent_component_exports, {
  DialogContent: () => DialogContent
});
module.exports = __toCommonJS(DialogContent_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var React = __toESM(require("react"));
var import_react = require("@floating-ui/react");
var import_focus = require("@react-aria/focus");
var import_Dialog = require("./Dialog.component");
const DialogContent = React.forwardRef(function DialogContent2(_a, propRef) {
  var _b = _a, { triggerId } = _b, props = __objRest(_b, ["triggerId"]);
  const _a2 = (0, import_Dialog.useDialogContext)(), { context: floatingContext } = _a2, context = __objRest(_a2, ["context"]);
  const ref = (0, import_react.useMergeRefs)([context.refs.setFloating, propRef]);
  if (!floatingContext.open) return null;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.FloatingPortal, { id: triggerId, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_react.FloatingOverlay,
    {
      className: "z-10 grid place-items-center bg-[--dialog-overlay]",
      lockScroll: true,
      "data-testid": "overlay-content",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_focus.FocusScope, { contain: true, restoreFocus: true, autoFocus: true, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "div",
        __spreadProps(__spreadValues({
          ref,
          "aria-labelledby": context.labelId,
          "aria-describedby": context.descriptionId
        }, context.getFloatingProps(props)), {
          children: props.children
        })
      ) })
    }
  ) });
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DialogContent
});
//# sourceMappingURL=DialogContent.component.js.map